<template>
  <div class="neta-lists">
    <div class="list-menu">
      <a-menu v-model="currentList" mode="horizontal" :style="{background: 'transparent'}" align="center">
        <a-menu-item key="neta-list-attraction">
          <a-icon type="tag" />
          Vonzerők
        </a-menu-item>

        <a-menu-item key="neta-list-event" :disabled="false">
          <a-icon type="calendar" />
          Események
        </a-menu-item>

          <a-menu-item key="neta-list-multi-attraction" :disabled="false">
              <a-icon type="tags" />
              Multi TOBok
          </a-menu-item>

          <a-menu-item key="neta-list-multi-event" :disabled="false">
              <a-icon type="calendar" />
              Multi események
          </a-menu-item>
      </a-menu>
    </div>

    <div class="list-content">
      <router-view />
    </div>
  </div>
</template>

<script>

import store from "@/store";
import { SET_NAVIGATION_PROGRESS_STATE } from "@/mutation_types";

export default {
  name: 'NetaListView',

  beforeRouteUpdate(to, from, next) {
    if (to.name !== 'neta-list') {
      next();

      return;
    }

    store.commit({
      type: SET_NAVIGATION_PROGRESS_STATE,
      navigationProgress: false
    })

    return false;
  },

  computed: {
    currentList: {
      get() {
        return [this.$route.name]
      },

      set(routeName) {
        this.$router.push({
          name: routeName[0]
        });
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.list-menu {
  margin-bottom: 10px;
}
</style>